import { ensureSiAdmin, post, useTranslate } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';
import { useUser } from './useUser';

interface Params {
  inviteId: string;
}

export function useSendOnboardingReminder() {
  const queryClient = useQueryClient();
  const { user } = useUser();
  const { t, translate } = useTranslate();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ inviteId }: Params) => {
      ensureSiAdmin(user, translate(t.adminAccessRequired));
      return post({
        url: `/api/admin/invites/${inviteId}/onboarding-reminder`,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getInvites,
      });
    },
  });

  const sendOnboardingReminder = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    sendOnboardingReminder,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
